// extracted by mini-css-extract-plugin
export default {"root":"IconAirPurifier_root__QrEQx"};